<template>
  <directory :main-class="'col-12'"/>
</template>

<script>
import Directory from './Directory'

export default {
  name: 'DirectoryBase',

  components: {
    Directory,
    // DirectoryMobile,
  }
}
</script>